import { useContext } from "react";
import { AppContext } from "../App";
import { formatDate, formatMoney } from "../Helpers";
import { MdArrowOutward } from "react-icons/md";

export default function One({ data }) {
  const appContext = useContext(AppContext);

  function view() {
    appContext.navTo({
      item: "side-view",
      subItem: "debt-options",
      extraItem: data.uuid,
    });
  }

  return (
    <div className="entity-card p-3 mb-2 border rounded bg-white shadow-sm" onClick={view} style={{ cursor: "pointer" }}>
      <div className="entity-card-main w-100">
        
        {/* Responsive Header Row - Columns on mobile, side-by-side on desktop */}
        <div className="entity-card-title-row d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 mb-3">
          <div className="d-flex gap-2 align-items-center flex-wrap">
            <h6 className="entity-card-title mb-0 text-truncate font-bold" style={{ maxWidth: "220px" }}>
              {data.fullname}
            </h6> 

            
          </div>
          
          {/* Status Pills Wrap Safely on smaller viewports */}
          <div className="entity-card-chip-row d-flex gap-1 flex-wrap">
            <span className={`status-pill p-1 rounded small text-light ${data.status === "cancelled" ? "bg-danger" : "bg-success"}`}>
              {data.status}
            </span>
          </div>

        </div>

        {/* Responsive Metadata View Grid Layout */}
        <div className="entity-card-meta-grid row g-2 text-muted small">
          <div className="col-6 col-sm-4 col-md-auto pe-md-3">
            <span className="d-block text-uppercase tracking-wider text-muted extra-small" style={{ fontSize: "10px" }}>Motorcycle</span>
            <span className="font-semi-bold text-primary">{data.model}</span>
          </div>
          
          <div className="col-6 col-sm-4 col-md-auto pe-md-3">
            <span className="d-block text-uppercase tracking-wider text-muted extra-small" style={{ fontSize: "10px" }}>DEBT</span>
            <span className="fw-semibold text-dark">{formatMoney(data.totalAmount || 0)}</span>
          </div>

          <div className="col-6 col-sm-4 col-md-auto pe-md-3">
            <span className="d-block text-uppercase tracking-wider text-muted extra-small" style={{ fontSize: "10px" }}>BALANCE</span>
            <span className="text-success font-semi-bold">{formatMoney(data.balance || 0)}</span>
          </div>

          <div className="col-6 col-sm-4 col-md-auto pe-md-3 d-flex flex-column align-items-center">
            <span className="badge bg-light text-dark border fw-normal">{data.officerName || "Not Assigned"}</span>
            <span className="text-dark mt-1">{formatDate(data.dateCreated)}</span>
          </div>

          <div className="col-12 col-sm-4 col-md-auto mt-2 mt-sm-0">
            
          </div>
        </div>
      </div>

      {/* Persistent End Action Target Key */}
      <div className="entity-card-end d-flex align-items-center justify-content-center ps-2 text-muted ms-auto d-sm-flex">
        <MdArrowOutward size={18} />
      </div>
    </div>
  );
}